
var sm = window.matchMedia( "(max-width: 640px)" );
var md = window.matchMedia( "(min-width: 641px)" );
var lg = window.matchMedia("(min-width: 1025px)");

function scrollToElementSmall(ele) {
	jQuery(window).scrollTop(ele.offset().top - 120).scrollLeft(ele.offset().left);
}
function scrollToElementLarge(ele) {
	jQuery(window).scrollTop(ele.offset().top - 165).scrollLeft(ele.offset().left);
}

jQuery(window).load(function () {
	var homesForSaleLarge = jQuery('#subpage-icons');
	var homesForSaleSmall = jQuery('#brochure');

	if (sm.matches) {
		scrollToElementSmall(homesForSaleSmall);
		console.log(`Mobile: ${homesForSaleSmall}`);
	}
	if (md.matches || lg.matches) {
		scrollToElementLarge(homesForSaleLarge);
		console.log(`Desktop: ${homesForSaleSmall}`);
	}
});

jQuery(document).ready(function() {
	jQuery('.print-button').on('click', function() {
		jQuery(".flowpaper-class").get(0).contentWindow.print();
	});
});